var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAsterisk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.82401 9.11103C8.72945 12.9127 11.6031 16.8067 14.5403 20.5314C17.4775 24.2561 20.3512 28.2271 23.606 31.7209C24.765 32.9984 27.0353 31.3208 26.0509 29.8894C23.3678 25.9184 20.256 22.1937 17.2553 18.5151C14.2546 14.8366 11.1745 11.0811 8.12615 7.3718C7.09417 6.1251 4.82377 7.80277 5.82401 9.11103Z",
    fill: "#99BCDF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.36371 29.7679C13.2229 22.8726 22.2727 16.1003 30.6715 8.6817C32.2591 7.23491 29.957 5.1417 28.3058 6.3884C19.3355 13.1144 10.8415 20.5947 2.37917 27.8594C1.01377 29.0291 2.98243 30.8299 4.36371 29.7679Z",
    fill: "#99BCDF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5404 1.27746V17.6078C13.3364 23.05 13.4901 28.4993 14.0008 33.9226C14.0008 34.2084 14.1179 34.4824 14.3263 34.6845C14.5347 34.8865 14.8175 35 15.1122 35C15.407 35 15.6897 34.8865 15.8981 34.6845C16.1065 34.4824 16.2236 34.2084 16.2236 33.9226C16.7052 28.4975 16.8219 23.0476 16.5728 17.6078L16.3189 1.27746C16.3189 0.938654 16.18 0.613744 15.9329 0.374169C15.6858 0.134594 15.3506 0 15.0011 0C14.6516 0 14.3165 0.134594 14.0693 0.374169C13.8222 0.613744 13.6834 0.938654 13.6834 1.27746H13.5404Z",
    fill: "#99BCDF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.04537 16.9924C3.55113 17.7591 6.13131 18.2749 8.74555 18.5315C11.4922 18.8855 14.2548 19.1625 17.0174 19.3165C22.446 19.6377 27.8936 19.4728 33.291 18.824C35.5138 18.5623 35.6249 15.207 33.291 15.3609C27.982 15.7431 22.6561 15.8561 17.3349 15.6995C14.6676 15.6226 12.0162 15.4378 9.39655 15.1762C6.77689 14.9145 4.1096 14.3758 1.45818 14.2989C1.10598 14.2957 0.764707 14.4174 0.498545 14.641C0.232383 14.8647 0.0596213 15.1749 0.0128145 15.5133C-0.0339922 15.8517 0.0483743 16.1951 0.244366 16.4788C0.440358 16.7625 0.736483 16.967 1.07711 17.0539L1.04537 16.9924Z",
    fill: "#99BCDF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsterisk);
export default __webpack_public_path__ + "static/media/asterisk.440fba8944a303fbdf8d83e738f71982.svg";
export { ForwardRef as ReactComponent };